import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

//This reducer function handles user preferences.
export default function ConfigurationsReducer(
	state = initialState.configurations,
	action
) {
	switch (action.type) {
		case types.GET_CONFIGURATIONS: {
			return action.response;
		}
		default:
			return state;
	}
}
